import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { VacanciesService, Vacancy } from '../../services/vacancies.service';

@Component({
  selector: 'app-vacancies',
  templateUrl: './vacancies.component.html',
  styleUrls: ['./vacancies.component.scss'],
  providers: [VacanciesService]
})
export class VacanciesComponent implements OnInit {
  vacancyData: Vacancy[];

  // @ViewChild('text_message') text_message: ElementRef;
  putMessage = false;
  today = new Date();
  x = 0;
  y = 0;
  scroll(x, y) {
    this.x = x;
    this.y = y;
    window.scrollTo(this.x, this.y);
  }

  constructor(private serviceVacancy: VacanciesService) { }

  ngOnInit() {
    this.vacancyData = this.serviceVacancy.getVacancies();
    // console.log( this.vacancyData[1]);
  }

}
